export const navItemLabel = (label: string, badge?: number) =>
  badge != null && badge > 0 ? `${label} (${badge})` : label;
